import CryptoJS from 'crypto-js'

/**
 * 敏感字段传输加密（AES-128 / ECB / PKCS7 + 标准 Base64），对应后端 PhoneCryptUtil。
 * 只是防抓包的混淆手段，不替代 HTTPS 与验签；密钥与小程序同源
 * （uni-app/PTE_uni/src/common/phone-crypt.ts 的 phoneCryptKey），三端必须一致。
 */
const CRYPT_KEY = 'eZR7f0SQZdJGXDur'

/**
 * 后端会在 Controller 层解密的接口白名单，键为请求路径（与本前端调用写法一致），值为需加密的字段。
 * 不在表内的接口原样发送，避免后端没解密逻辑时把密文当明文用。
 */
const ENCRYPTED_FIELDS_BY_PATH: Record<string, string[]> = {
  '/api/message/sendSms': ['phone'],
  '/api/message/sendVoiceCode': ['phone'],
  '/api/auth/loginPhone': ['phone'],
  '/api/auth/validationUserPhone': ['phone'],
  '/api/user/password/login': ['phone', 'password'],
  '/api/wechat/bind/phone': ['phone'],
  '/api/user/password/set': ['password', 'confirmPassword'],
  '/api/user/password/updateByOldPassword': ['oldPassword', 'newPassword', 'confirmPassword'],
  // code 是数字验证码，保持原样
  '/api/user/password/updateByCode': ['newPassword', 'confirmPassword']
}

export const encryptField = (value: string): string => {
  return CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value), CryptoJS.enc.Utf8.parse(CRYPT_KEY), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }).toString()
}

/**
 * 命中白名单时，把表内非空字符串字段逐个加密，返回新对象；其余情况原样返回。
 * 只改请求体，不动请求头——验签（sign）要求以明文手机号参与计算。
 */
export const encryptRequestData = <T>(url: string, data: T): T => {
  const fields = ENCRYPTED_FIELDS_BY_PATH[url]
  if (!fields || data == null || typeof data !== 'object' || Array.isArray(data)) {
    return data
  }
  const body = data as Record<string, unknown>
  const result = { ...body }
  for (const key of fields) {
    const value = body[key]
    if (typeof value === 'string' && value.length > 0) {
      result[key] = encryptField(value)
    }
  }
  return result as T
}
